module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_reason04-636f81db9d7543275c68fd2cc2c185be.png";